<template>
	<div>
		<div class="navbar">
			<b-button 
				to="/exact" 
				:data="data" 
				:vcleanExactCodes="vcleanExactCodes"
				:exactData="exactData"
				variant="outline-light">
				NOVA PESQUISA
			</b-button>
		</div>
		<b-container>
			<b-row>
				<b-col cols="12">
					<span class="title">CÓDIGO:</span>
					<span>{{ item && item.codigo }}</span>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<span class="title">TAMANHO:</span>
					<span>{{ item && item.tamanho }} POLEGADAS</span>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<span class="title">GRUPO:</span>
					<span>{{ item && item.grupo }}</span>
				</b-col>
			</b-row>
			<b-row v-if="item.fotosLimpador">
				<b-col cols="12" :md="12">
					<b-card no-body>
						<b-carousel id="carousel" :interval="4000" controls indicators no-hover-pause img-width="100%"
							background="#ababab" style="width: 100%; max-height: 100%; text-shadow: 1px 1px 2px #333;">

							<b-carousel-slide v-for="photo in item.fotosLimpador" :key="photo" :img-src="photo">
							</b-carousel-slide>

						</b-carousel>
					</b-card>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12" :md="12">
					<b-card no-body v-if="item && item.videoLimpador">
						<b-embed type="embed" v-if="item && item.videoLimpador" :src="item.videoLimpador" allowfullscreen />
					</b-card>
				</b-col>
			</b-row>
			
			<b-row class="mt-3">
				<span class="column-header-title column-header">{{ item.descricao }}</span>
			</b-row>
			<b-row v-if="tipo == 'LIMPADOR'" class="pt-2 pb-4" style="background-color: #e9ecef;">
				<b-col>
						<p class="mb-6 pt-6"><b>VEÍCULOS</b></p>
				</b-col>
				<b-col>
						<p class="mb-6 pt-6"><b>CONECTORES</b></p>
				</b-col>
			</b-row>
			<div v-if="tipo == 'LIMPADOR'">

			<b-row v-if="linha.conector" style="background-color: #e9ecef;" v-for="linha in item.exactVeiculoConector" :key="linha">
				<!-- <div v-for="linha in item.exactVeiculoConector" :key="linha" style="width: 100%"> -->
					<b-col>
						<p><b>
							{{ linha.veiculo }}
						</b></p>
					</b-col>
					<b-col>
						<p><b>
							{{ linha.conector }}
						</b></p>
					</b-col>
				<!-- </div> -->
			</b-row>
			</div>

			<b-row v-if="tipo == 'CONECTOR'" class="pt-2 pb-4" style="background-color: #e9ecef; width: 100%">
				<b-col>
						<p class="mb-6 pt-6"><b>APLICAÇÕES</b></p>
				</b-col>
				<b-col>
						<p class="mb-6 pt-6"><b>POLEGADAS</b></p>
				</b-col>
			</b-row>
			<div v-if="tipo == 'CONECTOR'">

			<b-row v-if="linha.tamanho" v-for="linha in item.exactLimpadorPolegada" :key="linha" style="background-color: #e9ecef; width: 100%;">
				<!-- <div v-for="linha in item.exactLimpadorPolegada" :key="linha" style="width: 100%;"> -->
					<b-col>
						<p><b>
							{{ linha.veiculo }}
						</b></p>
					</b-col>
					<b-col>
						<p><b>
							{{ linha.tamanho }}"
						</b></p>
					</b-col>
				<!-- </div> -->

			</b-row>
			</div>

		</b-container>
		<div id="modal" class="modal">
			<span class="modal-close">&times;</span>
			<img class="modal-content" id="modal-image">
		</div>
	</div>
</template>
  
<script>
/* eslint-disable */
export default {
	name: 'ExactDetail',
	props: {
		code: String,
		data: Array,
		exactData: Array,
		vcleanExactCodes: Array,
		codigosLimpadores: Array,
		codigosConectores: Array,
	},

	data() {
		return {
			item: {},
			tipo: ''
		};
	},

	methods: {
		// init: function () {
		// 	let isLimpador = this.codigosLimpadores.find(item => item.codigo == this.code);
		// 	let isConector = this.codigosConectores.find(item => item.codigo == this.code);
		// 	if (isLimpador){
		// 		this.item = this.codigosLimpadores
		// 	}else if(isConector){
		// 		this.item = this.codigosConectores
		// 	}
		// }
	},

	async mounted() {
		let limpadorItem = await this.codigosLimpadores.find(item => item.codigo == this.code);
		let conectorItem = await this.codigosConectores.find(item => item.codigo == this.code);
		if (limpadorItem){
			this.item = limpadorItem
			this.tipo = "LIMPADOR"
		}else if(conectorItem){
			this.item = conectorItem
			this.tipo = "CONECTOR"
		}
	}
};
</script>
  
<style scoped>
input[type='text'] {
	margin-bottom: 15px;
}

.navbar {
	margin-bottom: 15px;
	background-color: #e9ecef;
	border: 1px solid #dfe4e8;
	border-radius: calc(0.25rem - 1px);
}

.title {
	font-weight: bold;
	margin-right: 5px;
}

.description {
	padding: 15px 10px;
}

.card {
	align-items: center;
	margin-top: 30px;
	padding: 10px;
}

.card-img {
	cursor: pointer;
	transition: 0.3s;
	width: 75%;
}

.card-img:hover {
	opacity: 0.8;
}

.column-header {
	width: 100%;
	font-weight: bold;
	padding: 5px 0;
	background-color: #e9ecef;
	border: 1px solid #dfe4e8;
	border-radius: calc(0.25rem - 1px);
	margin-bottom: 10px;
}

.column-header>span {
	display: block;
}

.column-header-title {
	padding-bottom: 10px;
	font-weight: bold;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
	background-color: grey !important;
}
</style>
  